/* src/app/admin-dashboard/billing/billing.component.css */
.v2-recon-toolbar {
  margin-top: 0;
}
.v2-month-select {
  min-width: 190px;
}
.po-check {
  border: 2px solid #9ca3af;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 14px;
}
.po-check.po-prod {
  border-color: #dc2626;
}
.po-check-head,
.po-check-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}
.po-check-foot {
  margin: 10px 0 0;
}
.po-env {
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 4px;
  background: #6b7280;
  color: #fff;
}
.po-prod .po-env {
  background: #dc2626;
}
.po-blocked td {
  background: rgba(220, 38, 38, 0.06);
}
.po-msg {
  font-size: 12px;
  color: #92400e;
  margin: 2px 0;
}
.po-msg.po-err {
  color: #b91c1c;
}
.po-hint {
  font-size: 12px;
  opacity: 0.7;
}
/*# sourceMappingURL=billing.component.css.map */
